import InputNumber from './components/InputNumber';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'inputNumber',
  pluginComponent: InputNumber,
});
